<!--理财-->
<template>
    <div class="id">
        <div class="navBar" @click="$router.back()">
            <van-icon name="arrow-left" />
            {{ $t('策略订单') }}
        </div>
        <div class="boxBtn">
            <van-tabs v-model="active" @change="getUserOrderList" background="#12141e" title-active-color="#ffffff"
                title-inactive-color="#888" color="#dfdfdf" :swipeable="false">
                <van-tab v-for="(item, index) in source" :key="index" :title="item.name">
                    <div class="accountS">
                        <div class="boxT" v-for="v in orderList" :key="v.id">
                            <div class="contentQ">
                                <div class="boxW">
                                    <van-image v-for="value in v.product_list" :key="value.id" width="30"
                                        :src="value.image" class="img" />
                                    <div>{{ v.invest }}</div>
                                    <div class="boxWq" v-if="active == 0">{{ $t('进行中') }}</div>
                                    <div class="boxWq" v-if="active == 1">{{ $t('已结束') }}</div>
                                </div>
                                <!-- <div class="boxBtn" >
                                    {{ $t('收益详情') }}
                                </div> -->
                            </div>
                            <div class="boxQ">
                                <div>{{ $t('机器人ID') }}</div>
                                <div>{{ v.id }}</div>
                            </div>
                            <div class="boxQ">
                                <div>{{ $t('投入金额') }}</div>
                                <div>{{ v.amount }}USDT</div>
                            </div>
                            <div class="boxQ">
                                <div>{{ $t('投资') }}</div>
                                <div style="color: #00f0f0;">{{ v.order_rate }}%</div>
                            </div>
                            <div class="boxQ">
                                <div>{{ $t('套利次数') }}</div>
                                <div>{{ v.time }}</div>
                            </div>
                            <div class="boxQ">
                                <div>{{ $t('委托时间') }}</div>
                                <div>{{ v.startdate }}</div>
                            </div>
                            <div class="boxQ">
                                <div>{{ $t('运行时常') }}</div>
                                <div>{{ v.day }}h</div>
                            </div>
                            <div class="boxQ">
                                <div>{{ $t('总收益') }}</div>
                                <div>{{ v.totalincome }}</div>
                            </div>
                            <div class="boxQ">
                                <div>{{ $t('网格数量') }}</div>
                                <div>{{ v.number }}</div>
                            </div>
                            <div class="boxQ">
                                <div>{{ $t('服务费') }}</div>
                                <div>{{ v.commission }}USDT</div>
                            </div>
                            <div class="boxQ">
                                <div>{{ $t('结束时间') }}</div>
                                <div>{{ v.expire }}</div>
                            </div>
                        </div>
                    </div>
                </van-tab>
            </van-tabs>
        </div>




    </div>
</template>
<script>
import { get } from '@/http/request'
import apis from '@/http/api';

export default {
    components: {
    },
    data() {
        return {
            active: 0,
            source: [
                {
                    name: this.$t('进行中')
                },
                {
                    name: this.$t('已结束')
                }
            ],
            orderList: []
        };
    },
    mounted() {
        this.getUserOrderList()
    },
    beforeUnmount() { },
    methods: {
        async getUserOrderList() {
            const res = await get(apis.getUserOrderList, { limit: 999, status: this.active })
            if (res.code == 1) {
                this.orderList = res.data
                return
            }
        },
    },
};
</script>
<style lang="less" scoped>
::v-deep .van-cell {
    padding: 0;
}

.navBar {
    padding: 15px 10px;
    font-size: 18px;
    font-weight: 700;
    border-radius: 4px;
}

.boxBtn {
    padding: 10px;
    background-color: #12141e;
    border-radius: 10px;

    ::v-deep .van-tabs__wrap {
        border-bottom: 1px solid #20212c;
    }

    .accountS {
        padding: 0 10px;
        overflow-y: auto;
        height: 78vh;
        scrollbar-width: none;
        /* Firefox */
        -ms-overflow-style: none;

        .boxT {
            border-bottom: 1px solid #252733;
            padding: 10px 0;
        }

        .contentQ {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding-top: 10px;

            .boxBtn {
                background-color: #1a1b24;
                color: #fff;
                font-size: 12px;
                padding: 6px 12px;
                border-radius: 20px;
            }

            .boxW {
                display: flex;
                align-items: center;
                justify-content: space-between;
                position: relative;

                .img:nth-child(2) {
                    position: relative;
                    left: -10px;
                }

                .boxWq {
                    color: #00f0ff;
                    background-color: #000;
                    margin-left: 15px;
                    padding: 6px 12px;
                    border-radius: 15px;
                    font-size: 12px;
                }
            }
        }

        .boxQ {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 8px 0;

            div:nth-child(1) {
                color: #5e5e7a;
            }
        }


    }
}


.id {
    color: #fff;
    padding: 0 15px;
    padding-top: 50px;
    font-size: 14px;

}
</style>